/**
 * Formats job time strings (HH:mm, HH:mm:ss, or compact HHmm) as 12-hour clock,
 * e.g. "2:30 PM". Returns null when there is no time to show.
 */
export function formatJobTime12h(
  time: string | null | undefined,
): string | null {
  if (time == null || String(time).trim() === '') {
    return null;
  }
  const raw = String(time).trim();
  try {
    const timeStr = raw.includes(':')
      ? raw
      : `${raw.slice(0, 2)}:${raw.slice(2)}`;
    const [hours, minutesPart] = timeStr.split(':');
    const hour = parseInt(hours, 10);
    if (Number.isNaN(hour)) {
      return raw;
    }
    const minute = (minutesPart || '00').padStart(2, '0').slice(0, 2);

    if (hour === 0) {
      return `12:${minute} AM`;
    }
    if (hour < 12) {
      return `${hour}:${minute} AM`;
    }
    if (hour === 12) {
      return `12:${minute} PM`;
    }
    return `${hour - 12}:${minute} PM`;
  } catch {
    return raw;
  }
}
